module.exports = __webpack_public_path__ + "_assets/img/bell-v2.c1ca7f60.svg";